import style from "@/styles/pages/ForgotPassword/ForgotPassword.module.css";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router-dom";
import { createApiClient } from "@/lib/Requests";
import FadeTransition from "@/styles/animation/FadeTransition";
import { useForm } from "react-hook-form";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

export default function PasswordResetRequested() {
    const client = createApiClient({ timeout: 60000 });
    const [resetInProgress, setResetInProgress] = useState(false);
    const [email, setEmail] = useState("");
    const [emailResent, setEmailResent] = useState(false);

    const navigate = useNavigate();
    const { state } = useLocation();

    const handleClick = () => {
        navigate("/login", { replace: true });
    }

    const methods = useForm({
        defaultValues: {
            email: "",
        },
    });

    useEffect(() => {
        if (state) {
            setEmail(state.email);
        }
    });

    const resetPasswordResetRequest = (email: string) => {
        setResetInProgress(true);
        setEmailResent(false);
        client.apiAuthForgotpassword(email).then((result) => {

            console.log(result)
            setResetInProgress(false);
            setEmailResent(true);


        }).catch((error) => {
            setResetInProgress(false);
            console.log("Error creating password reset request", error);
            if (error && error.response) {
                methods.setError("email", {
                    type: "account",
                    message: error.response.message,
                });
            }

        });
    };

    return (
        <FadeTransition>
            <main aria-labelledby="main-content">
                <div className="main-container max-md:mt-10">
                    <div className={clsx(style.login, "container", "mt-10")}>
                        <div className={style.emHeading}>
                            <div className="grid grid-cols-1">
                                <h1>Password Reset Sent</h1>
                                <div className="max-sm:hidden">
                                    <p>We've sent an email to <b>{email}</b></p>
                                    <p>containing a link to reset your password that applies to you.</p>
                                </div>
                            </div>
                        </div>
                        {emailResent && (
                            <div
                                className={clsx(
                                    "flex flex-row pcaautocomplete mt-5",
                                    style.successContainer
                                )}
                            >
                                <img src="assets/success-info-icon.svg" alt="error" />
                                <span className="text-sm ml-2 mt-1">
                                    Your password reset email was successfully resent. Please check your inbox.
                                </span>
                            </div>
                        )}
                        {methods.formState?.errors?.email?.message && (
                            <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                {methods.formState.errors.email.message}
                            </span>
                        )}
                        <div className="flex relative">
                            <button
                                onClick={() => {
                                    resetPasswordResetRequest(email);
                                }}
                                disabled={resetInProgress}
                                className={clsx(
                                    "primary mt-5 w-full sm:w-28 h-11 px-6",
                                    resetInProgress ? style.loginDisabled : ""
                                )}
                            >
                                <FontAwesomeIcon
                                    icon={faSpinner}
                                    spin
                                    style={{ marginRight: 8 }}
                                    className={clsx(resetInProgress ? "" : "hidden")}
                                />
                                Resend Email
                            </button>
                        </div>

                        <div className="relative mt-5">
                            <div className="active text-center flex justify-center" onClick={handleClick}>
                                <img
                                    src="assets/arrow-back.svg"
                                    className={clsx(
                                        "w-5 h-6 top-6"
                                    )}
                                    alt="error"
                                />
                                <span className="ml-2 cursor-pointer">Back to Login</span>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </FadeTransition>
    );
}